import * as types from './mutation-types';
import { SEARCH_PARAMS, PAGING_INFO, SELECTED_ROW, POPUP_SEARCH_PARAMS } from './state';

export default {
	[types.STATE_INIT]: state => {
		// main
		state.searchParams = SEARCH_PARAMS();
		state.pagingInfo = PAGING_INFO();
		state.mainResultList = [];

		// popup
		state.popupSearchParams = POPUP_SEARCH_PARAMS();
		state.selectedRow = SELECTED_ROW();
		state.popupPagingInfo = PAGING_INFO();
		state.resultList = [];
		state.okReport = [];
		state.ngReport = [];

		state.isPqyUser = false;

		state.attentionList = [];
		state.okList = []; //결과는 합격인데, 리스트가 다 불량인경우
		state.ngList = []; //결과는 불합격인데, 리스트가 다 합격인경우

		//selectbox
		state.oputStCdList = [];
		state.indvJgmtCdList = [];
		state.powQltyCdList = [];
		state.apenCkuCdList = [];
		state.clfcStCdList = [];
		state.tymaCdList = [];
		state.cdcnStCdList = [];
		state.partBloCdList = [];
		state.partSrgCdList = [];
	},
	[types.DEFAULT_ASSIGN]: (state, { key, value }) => {
		state[key] = value;
	},
	[types.SELECTED_ROW]: (state, { key, value }) => {
		state.selectedRow[key] = value;
	},
	[types.SEARCH_PARAM]: (state, { key, value }) => {
		state.searchParams[key] = value;
	},
	[types.POPUP_SEARCH_PARAM]: (state, { key, value }) => {
		state.popupSearchParams[key] = value;
	},
	[types.PAGING_INFO]: (state, { key, value }) => {
		state.pagingInfo[key] = value;
	},
	[types.POPUP_PAGING_INFO]: (state, { key, value }) => {
		state.popupPagingInfo[key] = value;
	},
	[types.ERROR_LIST]: (state, { key, value }) => {
		state[key].push(value);
	},
	[types.ATTENTION_LIST]: (state, newElement) => {
		!state.attentionList.includes(newElement) && state.attentionList.push(newElement);
	},
	[types.POPUP_INIT]: state => {
		state.popupSearchParams = POPUP_SEARCH_PARAMS();
		state.selectedRow = SELECTED_ROW();
		state.popupPagingInfo = PAGING_INFO();
		state.ngReport = [];
		state.resultList = [];
	}
};
